import { Alert } from "@mui/material";

export const ColorFilterNcsDisclaimer = () => {
  return (
    <Alert severity="info">
      NCS – Natural Colour System® property of and used under licence granted by
      NCS Colour AB, Stockholm 2025.
    </Alert>
  );
};
